/*

Usage
-----
<div jv-action-validation jv-validation-result="modalData.validationResult"></div>

*/

angular.module('jv.candidate.action.validation.directive', [])
.directive('jvActionValidation', [
    function() {
        return {
            scope: {
                validationResult: '=jvValidationResult',
            },
            templateUrl: 'directives/action-validation-template.html'
        };
    }
]);